import { faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";

export default function IntervalForm(props) {
    let plusIconColor = "";
    let deleteIconColor = "#dc3545";
    if (props.theme === "default_theme") plusIconColor = "#1E874A";
    if (props.theme === "evraz_theme") plusIconColor = "#ed7817";
    let all_intervals = props.intervals.concat(props.my_intervals);

    return <>
            {all_intervals.length > 0 &&
                all_intervals.map((el, i) => 
                <Form onSubmit={props.handleDeleteInterval} className={`mt-4`} key={i}>
                    <Row className="mb-4">
                        <Form.Group as={Col} md={el.is_edit ? "5" : "6"}>
                            <Form.Control
                                required
                                readOnly
                                type="text"
                                name="name"
                                placeholder="Название интервала"
                                value={el.name}
                                className="Field select2 select2-no-search mw-100 w-100" />
                        </Form.Group>
                        <Form.Group as={Col} md="3">
                            <Form.Control
                                required
                                readOnly
                                type="time"
                                name="start"
                                value={el.start}
                                className="Field select2 select2-no-search mw-100 w-100" />
                        </Form.Group>
                        <Form.Group as={Col} md="3">
                            <Form.Control
                                required
                                readOnly
                                type="time"
                                name="end"
                                value={el.end}
                                className="Field select2 select2-no-search mw-100 w-100" />
                        </Form.Group>
                        {el.is_edit &&
                            <Form.Group as={Col} md="1">
                                <button type="submit" className="Field select2 select2-no-search mw-100 w-100" style={{background: "white"}} >
                                    <FontAwesomeIcon style={{color: deleteIconColor}} icon={faTimes}/>
                                </button>
                            </Form.Group>}
                    </Row>
                </Form>
                )}
            <Form onSubmit={props.handleAddInterval} className={`mt-4`}>
                <Row className="mb-4">
                    <Form.Group as={Col} md="5">
                        <Form.Control
                            required
                            type="text"
                            name="name"
                            placeholder="Название интервала"
                            onChange={props.handleOnChange}
                            className="Field select2 select2-no-search mw-100 w-100" />
                    </Form.Group>
                    <Form.Group as={Col} md="3">
                        <Form.Control
                            required
                            type="time"
                            name="start"
                            onChange={props.handleOnChange}
                            className="Field select2 select2-no-search mw-100 w-100" />
                    </Form.Group>
                    <Form.Group as={Col} md="3">
                        <Form.Control
                            required
                            type="time"
                            name="end"
                            onChange={props.handleOnChange}
                            className="Field select2 select2-no-search mw-100 w-100" />
                    </Form.Group>
                    <Form.Group as={Col} md="1">
                        <button type="submit" className="Field select2 select2-no-search mw-100 w-100" style={{background: "white"}}>
                            <FontAwesomeIcon style={{color: plusIconColor}} icon={faPlus}/>
                        </button>
                    </Form.Group>
                </Row>
            </Form>
           </>
}